import axiosIns from "@/api/axios";

const state = {
  isLoadingExpanses: false,
};

const mutations = {
  SET_LOADING_EXPANSES(state, payload) {
    state.isLoadingExpanses = payload;
  },
};

const actions = {
  async saveExpanses({ commit }, payload) {
    try {
      commit("SET_LOADING_EXPANSES", true);
      const response = await axiosIns.post("/actual-v2", payload);
      return response.data;
    } catch (error) {
      console.error("Error saving expanses:", error);
      throw error;
    } finally {
      commit("SET_LOADING_EXPANSES", false);
    }
  },

  async updateExpanses({ commit }, { id, payload }) {
    try {
      commit("SET_LOADING_EXPANSES", true);
      const response = await axiosIns.put(`/actual/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error updating expanses:", error);
      throw error;
    } finally {
      commit("SET_LOADING_EXPANSES", false);
    }
  },
};

const getters = {
  isLoadingExpanses: (state) => state.isLoadingExpanses,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
